import { RouteRecordRaw } from "vue-router";

export const configurationRoutes: RouteRecordRaw[] = [
  {
    path: "/configuration/:section?",
    name: "ConfigurationView",
    component: () => import("../views/ConfigurationView.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "",
      requiredRight: "",
    },
  },
];
